module.exports = __webpack_public_path__ + "static/media/api-info.cfc7bfbc.jpg";